import AutodeskConnectAction from "../controls/AutodeskConnectAction";

export default function AutodeskImportConnectStep(p: {
  workspaceId: number;
  onConnected(): void;
}) {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-thin">
        Connect your <span className="font-normal">Autodesk account</span>
      </h1>
      <p className="text-sm font-light">
        Connect your Autodesk account to browse your Autodesk Forma hubs and
        import models into this project.
      </p>
      <AutodeskConnectAction
        workspaceId={p.workspaceId}
        label="Connect my Autodesk account"
        onConnected={p.onConnected}
      />
    </div>
  );
}
